import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Progress, Tooltip } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone, HistoryOutlined, } from '@ant-design/icons';
import { useI18n } from 'applib-frontend';
import './style.less';
import TooltipContent from './TooltipContent';
const TableStatus = ({ text, progress, state, percentage, url, }) => {
    const { intl } = useI18n();
    if (state === 'FAILED') {
        return (_jsxs(_Fragment, { children: [_jsx("div", { children: _jsx(CloseCircleTwoTone, { twoToneColor: "red", className: "icon" }) }), _jsx(Tooltip, { title: (_jsx(TooltipContent, { progress: progress, text: text, url: url })), trigger: ['click', 'hover'], placement: "right", children: _jsx("p", { className: "fail-detail", children: intl.formatMessage({ id: 'detail' }) }) })] }));
    }
    if (state === 'STOPPING') {
        return intl.formatMessage({ id: 'stopping' });
    }
    if (state === 'SUCCESS') {
        return _jsx(CheckCircleTwoTone, { twoToneColor: "yellowgreen", className: "icon" });
    }
    if (progress === 'scheduled') {
        return (_jsxs(_Fragment, { children: [intl.formatMessage({ id: text }), _jsx("div", { children: _jsx(HistoryOutlined, { className: "icon beey-grey" }) })] }));
    }
    return percentage > -1 ? (_jsxs("div", { children: [intl.formatMessage({ id: text }), _jsx(Progress, { percent: percentage, status: "active", size: "small", strokeColor: {
                    from: ' #fef9e9',
                    to: '#f3ab58',
                } })] })) : (`${intl.formatMessage({ id: text })}`);
};
export default TableStatus;
